import styled from '@emotion/styled';
import { Box } from '@mui/material';
import placeholderImage from 'assets/images/placeholder.svg';
import React, { useEffect, useState } from 'react';

const ColImage = ({ src, alt }) => {
  const [loading, setLoading] = useState(true);
  const [imgSrc, setImgSrc] = useState(src || placeholderImage);

  useEffect(() => {
    setImgSrc(src || placeholderImage);
    setLoading(true);
  }, [src]);

  return (
    <Box
      sx={{
        // width: '100%',
        // height: '100%',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
      }}
    >
      <Image
        src={imgSrc}
        alt={alt}
        onLoad={() => setLoading(false)}
        onError={() => {
          setImgSrc(placeholderImage);
          setLoading(false);
        }}
        style={{ opacity: loading ? 0 : 1 }}
      />
    </Box>
  );
};

export default ColImage;

const Image = styled.img`
  width: 100%;
  border-radius: 4px;
  height: 40px;
  object-fit: contain;
`;
